import { useMemo } from 'react'
import { Grid, styled } from '@mui/material'
import HomeAppCard from './HomeAppCard/HomeAppCard'
import { CardSize } from './HomeAppCard/CardSize'
import { useBookmarkedApps } from 'features/apps/hooks/appsHooks'

const StyledContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5)
}))

export function HomeApps() {
  const apps = useBookmarkedApps()

  const {
    gridSize,
    cardSize,
    displayDescription
  }: { gridSize: number; cardSize: CardSize; displayDescription: boolean } = useMemo(() => {
    const gridSize = apps.length === 1 ? 12 : apps.length === 2 ? 6 : 4
    const cardSize = apps.length === 1 ? 'large' : apps.length === 2 ? 'medium' : 'small'
    const displayDescription = apps.length <= 2

    return { gridSize, cardSize, displayDescription }
  }, [apps])

  if (apps.length === 0) return null

  return (
    <StyledContainer container spacing={3}>
      {apps.map((app, i) => (
        <Grid item key={i} xs={12} lg={gridSize}>
          <HomeAppCard {...app} cardSize={cardSize} displayDescription={displayDescription} />
        </Grid>
      ))}
    </StyledContainer>
  )
}

export default HomeApps
